export default __webpack_public_path__ + "media/images/logo-5eddc89544490a8d87970ac78c8ec6f1.svg";